export const ReturnsGridModes = Object.freeze({
  Shipment: 'shipment',
  Return: 'return',
} as const);

export type ReturnsGridMode = (typeof ReturnsGridModes)[keyof typeof ReturnsGridModes];
